import type { ReclaimActivationSurface } from "@redotech/redo-dispute-settings-common/reclaim-access-settings";
import { withReclaimActivationSurface } from "./steps/reclaim-activation/activation-surface";
import type { UnifiedOnboardingProductId } from "./types";

/** Deep link into unified onboarding for one product. */
export function unifiedOnboardingProductPath(args: {
  teamId: string;
  productId: UnifiedOnboardingProductId;
  /**
   * Only for a CTA the team record cannot reveal the channel from — the
   * in-dashboard Reclaim one. Everything else lets the server derive it, and
   * an invented surface here would decide what the merchant is charged.
   */
  surface?: ReclaimActivationSurface;
}): string {
  return withReclaimActivationSurface(
    `/stores/${args.teamId}/welcome/unified-onboarding?product=${args.productId}`,
    args.surface,
  );
}
